import { SIZE_STEP } from '../../styles/generated/data/types';

// The `size-*` dimension scale — the curated 4pt token scale (`--rc-size-*`, 12–80px) used
// to size elements (icon / avatar / control widths & heights) to consistent dimensions.
// Distinct from `space-*` (spacing); step numbers mirror it (`size-6` == `space-6` == 24px).
//
// Each step N maps to the `--rc-size-N` token and to the utility classes
// `.width-size-N` / `.height-size-N` (+ responsive `tablet-` / `mobile-` variants).
// width-and-height.utilities.json emits both the classes and this union. Steps are strings
// because they name a class suffix, like every other utility-backed prop value.
// Re-exported under its plural name because that is what consumers import.
export const SIZE_STEPS = SIZE_STEP;

export type SizeStep = typeof SIZE_STEPS[number];

export function isSizeStep(value: string): value is SizeStep {
  return (SIZE_STEPS as readonly string[]).includes(value);
}

// A size step → its width/height utility class at one breakpoint (`prefix` is `''` for the
// base and `tablet-` / `mobile-` otherwise).
export function sizeClass(dimension: 'width' | 'height', step: SizeStep, prefix = ''): string {
  return `${prefix}${dimension}-size-${step}`;
}
